


// import React, { useEffect, useState, useMemo } from "react";
// import { collection, getDocs, getDoc, doc } from "firebase/firestore";
// import { db, auth } from "../firebase";
// import Swal from "sweetalert2";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Link, useNavigate } from 'react-router-dom';
// import { signOut } from 'firebase/auth';
// import "./Dashboard.css";

// const FINES_PER_PAGE = 5;

// const Dashboard = () => {
//   const [finesData, setFinesData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const navigate = useNavigate();
//   const [userPage, setUserPage] = useState({}); // { userId: pageNumber }

//   useEffect(() => {
//     const fetchFines = async () => {
//       setLoading(true);
//       try {
//         const finesCollection = collection(db, "Fines");
//         const usersSnapshot = await getDocs(finesCollection);
//         const userPromises = usersSnapshot.docs.map(async (userDoc) => {
//           const userId = userDoc.id;
//           const userData = userDoc.data();
//           const totalFine = userData.TotalFine || 0;
//           const pendingFine = userData.PendingFine || 0;
//           const userInfoPromise = getDoc(doc(db, "users", userId));
//           const userFinesCollection = collection(db, "Fines", userId, "fines");
//           const finesPromise = getDocs(userFinesCollection);
//           const [userInfoDoc, finesSnapshot] = await Promise.all([
//             userInfoPromise,
//             finesPromise
//           ]);
//           const userName = userInfoDoc.exists()
//             ? userInfoDoc.data().userName || "Unknown User"
//             : "Unknown User";
//           const fines = finesSnapshot.docs.map((doc) => ({
//             id: doc.id,
//             ...doc.data(),
//           }));
//           return {
//             userId,
//             userName,
//             fines,
//             totalFine,
//             pendingFine,
//           };
//         });
//         const data = await Promise.all(userPromises);
//         setFinesData(data);
//       } catch (error) {
//         console.error("Error fetching fines:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Failed to load fines data",
//           confirmButtonColor: "#3085d6",
//         });
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchFines();
//   }, []);

//   const filteredData = useMemo(() => {
//     return finesData.filter(
//       (user) =>
//         user.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.userId.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }, [finesData, searchTerm]);

//   // For backwards compatibility, keep the same variable name
//   const sortedAndFilteredData = filteredData;

//   const summaryData = useMemo(() => {
//     const totalAllFines = finesData.reduce(
//       (sum, user) => sum + (user.totalFine || 0),
//       0
//     );
//     const totalPendingFines = finesData.reduce(
//       (sum, user) => sum + (user.pendingFine || 0),
//       0
//     );
//     const paidFines = totalAllFines - totalPendingFines;
//     const percentPending = totalAllFines
//       ? Math.round((totalPendingFines / totalAllFines) * 100)
//       : 0;
//     return {
//       totalAllFines,
//       totalPendingFines,
//       paidFines,
//       percentPending,
//       collectionRate: 100 - percentPending
//     };
//   }, [finesData]);

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-PK", {
//       style: "currency",
//       currency: "PKR",
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       navigate('/login');
//     } catch (error) {
//       console.error("Logout error:", error);
//     }
//   };



//   const formatDate = (date) => {
//   if (!date) return "";

//   const d = date?.toDate ? date.toDate() : new Date(date);

//   const day = String(d.getDate()).padStart(2, "0");

//   const month = d.toLocaleString("en-US", { month: "long" });

//   const year = d.getFullYear();

//   return `${day}-${month}-${year}`;
// };

//   // Helper to get current page for a user
//   const getUserPage = (userId) => userPage[userId] || 1;
//   // Helper to set page for a user
//   const setPageForUser = (userId, page) => {
//     setUserPage((prev) => ({ ...prev, [userId]: page }));
//   };

//   // --- Modern UI Start ---
//   return (
//     <div className="container-fluid py-4 px-2 px-sm-3 px-md-4 min-vh-100 gradient-background">
//       {/* Header & Actions */}
//       <div className="row mb-4">
//         <div className="col-12">
//           <div className="card shadow-lg border-0 rounded-4 glass-card">
//             <div className="card-body">
//               <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3 gap-3">
//                 <h2 className="h3 mb-0 text-primary fw-bold d-flex align-items-center">
//                   <i className="bi bi-cash-coin me-2"></i>
//                   User Fines Overview
//                 </h2>
//                 <div className="d-flex flex-wrap gap-2">
//                   {/* <Link to="/fines" className="btn btn-success rounded-pill px-4 d-flex align-items-center">
//                     <i className="bi bi-plus-circle me-2"></i> Add New Fine
//                   </Link> */}

//                   <Link to="/fines" className="btn btn-success rounded-pill px-4 d-flex align-items-center">
//                     <i className="bi bi-plus-circle me-2"></i> Add New Fine
//                   </Link>
                  
//                   <Link to="/user" className="btn btn-warning rounded-pill px-4 d-flex align-items-center">
//                     <i className="bi bi-people me-2"></i> User List
//                   </Link>
//                   <button onClick={handleLogout} className="btn btn-outline-danger rounded-pill px-4 d-flex align-items-center">
//                     <i className="bi bi-box-arrow-right me-2"></i> Logout
//                   </button>
//                 </div>
//               </div>
//               {/* Search Bar */}
//               <div className="row g-3 mb-4">
//                 <div className="col-12 col-md-6 col-lg-4">
//                   <div className="position-relative">
//                     <i className="bi bi-search position-absolute ms-3" style={{ zIndex: 5, top: "50%", transform: "translateY(-50%)" }}></i>
//                     <input
//                       type="text"
//                       className="form-control form-control-lg ps-5 rounded-pill border-0 shadow-sm"
//                       placeholder="Search users or ID..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//               {/* Summary Cards */}
//               <div className="row g-4 mb-2">
//                 {/* Total Fines Card */}
//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-gradient shadow border-0 rounded-4 h-100 glass-card" style={{ background: "linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)" }}>
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-primary bg-opacity-10 text-primary me-3">
//                           <i className="bi bi-cash-stack"></i>
//                         </div>
//                         <h6 className="fw-bold text-primary mb-0">Total Fines</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-0">
//                         {formatCurrency(summaryData.totalAllFines)}
//                       </h3>
//                       <div className="opacity-50 mt-2 small">All fines issued</div>
//                     </div>
//                   </div>
//                 </div>
//                 {/* Pending Fines Card */}
//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-gradient shadow border-0 rounded-4 h-100 glass-card" style={{ background: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)" }}>
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-warning bg-opacity-10 text-warning me-3">
//                           <i className="bi bi-hourglass-split"></i>
//                         </div>
//                         <h6 className="fw-bold text-warning mb-0">Pending Fines</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-0">
//                         {formatCurrency(summaryData.totalPendingFines)}
//                       </h3>
//                       <div className="opacity-50 mt-2 small">Yet to be collected</div>
//                     </div>
//                   </div>
//                 </div>
//                 {/* Collected Fines Card */}
//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-gradient shadow border-0 rounded-4 h-100 glass-card" style={{ background: "linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)" }}>
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-success bg-opacity-10 text-success me-3">
//                           <i className="bi bi-cash"></i>
//                         </div>
//                         <h6 className="fw-bold text-success mb-0">Collected Fines</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-0">
//                         {formatCurrency(summaryData.paidFines)}
//                       </h3>
//                       <div className="opacity-50 mt-2 small">Total paid (collected)</div>
//                     </div>
//                   </div>
//                 </div>
//                 {/* Collection Rate Card (4th) */}
//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-gradient shadow border-0 rounded-4 h-100 glass-card" style={{ background: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)" }}>
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-info bg-opacity-10 text-info me-3">
//                           <i className="bi bi-percent"></i>
//                         </div>
//                         <h6 className="fw-bold text-info mb-0">Collection Rate</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-0">
//                         {summaryData.collectionRate}%
//                       </h3>
//                       <div className="opacity-50 mt-2 small">Fines collected</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* User Cards Section */}
//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-grow text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="mt-3 text-muted">Loading fines data...</p>
//         </div>
//       ) : sortedAndFilteredData.length === 0 ? (
//         <div className="card shadow-sm border-0 rounded-3 p-4 text-center glass-card">
//           <div className="py-4">
//             <i className="bi bi-search text-muted" style={{ fontSize: "3rem" }}></i>
//             <h4 className="mt-3">No Results Found</h4>
//             <p className="text-muted mb-0">
//               No users found matching your search criteria.
//             </p>
//             {searchTerm && (
//               <button
//                 className="btn btn-outline-primary mt-3"
//                 onClick={() => setSearchTerm("")}
//               >
//                 Clear Search
//               </button>
//             )}
//           </div>
//         </div>
//       ) : (
//         <div className="row g-4">
//           {sortedAndFilteredData.map((user, idx) => {
//             // --- User Avatar/Initials ---
//             const getInitials = (name) => {
//               if (!name) return "?";
//               const parts = name.trim().split(" ");
//               if (parts.length === 1) return parts[0][0].toUpperCase();
//               return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
//             };
//             // --- Status Badge ---
//             const isPaid = user.pendingFine === 0 && user.totalFine > 0;
//             const statusBadge = isPaid ? (
//               <span className="badge bg-success rounded-pill px-3 py-2 d-flex align-items-center">
//                 <i className="bi bi-check-circle me-1"></i> Paid
//               </span>
//             ) : (
//               <span className="badge bg-warning text-dark rounded-pill px-3 py-2 d-flex align-items-center">
//                 <i className="bi bi-exclamation-triangle me-1"></i> Pending
//               </span>
//             );
//             // --- Card Gradient Header ---
//             // Pagination logic for this user's fines
//             const page = getUserPage(user.userId);
//             const totalFines = user.fines.length;
//             const totalPages = Math.ceil(totalFines / FINES_PER_PAGE) || 1;
//             const startIdx = (page - 1) * FINES_PER_PAGE;
//             const endIdx = startIdx + FINES_PER_PAGE;
//             const paginatedFines = user.fines.slice(startIdx, endIdx);

//             return (
//               <div key={idx} className="col-12 col-lg-6">
//                 <div className="card shadow-lg border-0 rounded-4 overflow-hidden h-100 transition-card glass-card mb-3">
//                   {/* Card Header with gradient and avatar/initials */}
//                   <div className="card-header py-3" style={{ background: "linear-gradient(90deg, #e0eafc 0%, #cfdef3 100%)" }}>
//                     <div className="d-flex align-items-center gap-3">
//                       {/* Avatar/Initials */}
//                       <div className="rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: 48, height: 48, background: "#6c63ff", color: "#fff", fontWeight: 700, fontSize: 22, boxShadow: "0 2px 8px rgba(108,99,255,0.15)" }}>
//                         {getInitials(user.userName)}
//                       </div>
//                       <div className="flex-grow-1">
//                         <div className="fw-bold fs-5 text-primary mb-0">{user.userName}</div>
//                         <div className="small text-muted">ID: {user.userId}</div>
//                       </div>
//                       <div className="text-end">
//                         {statusBadge}
//                       </div>
//                     </div>
//                   </div>
//                   {/* Card Body: Modern table style fines list */}
//                   <div className="card-body p-0">
//                     <div className="table-responsive">
//                       <table className="table table-hover align-middle mb-0 sticky-header">
//                         <thead className="bg-light sticky-top">
//                           <tr>
//                             <th className="px-3">Fine Reason</th>
//                             <th>Amount</th>
//                             <th>Date</th>
//                             <th>Status</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {paginatedFines.length > 0 ? (
//                             paginatedFines.map((fine, index) => {
//                               // Icon for fineType (default: info)
//                               let fineIcon = "bi-info-circle";
//                               if (fine.fineType && fine.fineType.toLowerCase().includes("late")) fineIcon = "bi-clock-history";
//                               if (fine.fineType && fine.fineType.toLowerCase().includes("damage")) fineIcon = "bi-exclamation-triangle";
//                               if (fine.fineType && fine.fineType.toLowerCase().includes("absent")) fineIcon = "bi-person-x";
//                               // Status badge
//                               const fineStatusBadge = fine.status === "Paid" ? (
//                                 <span className="badge bg-success rounded-pill px-2 py-1 d-flex align-items-center">
//                                   <i className="bi bi-check-circle me-1"></i> Paid
//                                 </span>
//                               ) : (
//                                 <span className="badge bg-warning text-dark rounded-pill px-2 py-1 d-flex align-items-center">
//                                   <i className="bi bi-clock me-1"></i> Pending
//                                 </span>
//                               );
//                               return (
//                                 <tr key={index} className={index % 2 === 0 ? "table-light" : "table-white"}>
//                                   <td className="px-3 d-flex align-items-center gap-2">
//                                     <i className={`bi ${fineIcon} text-secondary`}></i>
//                                     <span className="fw-medium">{fine.fineType}</span>
//                                   </td>
//                                   <td>
//                                     <span className="badge bg-primary bg-opacity-10 text-primary">
//                                       {formatCurrency(fine.amount)}
//                                     </span>
//                                   </td>
//                                   <td className="text-muted small">
//                                     {/* <i className="bi bi-calendar-event me-1"></i>{fine.date} */}
//                                     <td>{formatDate(fine.date)}</td>
//                                   </td>
//                                   <td>{fineStatusBadge}</td>
//                                 </tr>
//                               );
//                             })
//                           ) : (
//                             <tr>
//                               <td colSpan="4" className="text-center py-4 text-muted">
//                                 <i className="bi bi-inbox me-2"></i>
//                                 No fines recorded for this user
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                     {/* Pagination Controls */}
//                     {totalPages > 1 && (
//                       <nav className="d-flex justify-content-center align-items-center py-2">
//                         <ul className="pagination pagination-sm mb-0">
//                           <li className={`page-item${page === 1 ? " disabled" : ""}`}>
//                             <button className="page-link" onClick={() => setPageForUser(user.userId, page - 1)} disabled={page === 1}>&laquo; Prev</button>
//                           </li>
//                           {Array.from({ length: totalPages }, (_, i) => (
//                             <li key={i} className={`page-item${page === i + 1 ? " active" : ""}`}>
//                               <button className="page-link" onClick={() => setPageForUser(user.userId, i + 1)}>{i + 1}</button>
//                             </li>
//                           ))}
//                           <li className={`page-item${page === totalPages ? " disabled" : ""}`}>
//                             <button className="page-link" onClick={() => setPageForUser(user.userId, page + 1)} disabled={page === totalPages}>Next &raquo;</button>
//                           </li>
//                         </ul>
//                       </nav>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboard;





import React, { useEffect, useState, useMemo } from "react";
import { collection, getDocs, getDoc, doc } from "firebase/firestore";
import { db, auth } from "../firebase";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import "./Dashboard.css";

const FINES_PER_PAGE = 5;

const Dashboard = () => {
  const [finesData, setFinesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [userPage, setUserPage] = useState({});
  const [finesUsedOnEvent, setFinesUsedOnEvent] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFines = async () => {
      setLoading(true);
      try {
        const finesCollection = collection(db, "Fines");
        const usersSnapshot = await getDocs(finesCollection);

        const userPromises = usersSnapshot.docs.map(async (userDoc) => {
          const userId = userDoc.id;
          const userData = userDoc.data();
          const totalFine = userData.TotalFine || 0;
          const pendingFine = userData.PendingFine || 0;

          const userInfoDoc = await getDoc(doc(db, "users", userId));
          const finesSnapshot = await getDocs(collection(db, "Fines", userId, "fines"));

          const userName = userInfoDoc.exists() ? userInfoDoc.data().userName || "Unknown User" : "Unknown User";
          const fines = finesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

          return { userId, userName, fines, totalFine, pendingFine };
        });

        const data = await Promise.all(userPromises);
        setFinesData(data);

        // Fetch usedAmount from /fineAmountHistory/latest
        const latestDocRef = doc(db, "fineAmountHistory", "latest");
        const latestDocSnap = await getDoc(latestDocRef);
        setFinesUsedOnEvent(latestDocSnap.exists() ? latestDocSnap.data().usedAmount || 0 : 0);

      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Failed to load fines data", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchFines();
  }, []);

  // Search filter
  const filteredData = useMemo(() => {
    return finesData.filter(user =>
      user.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.userId.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [finesData, searchTerm]);

  // Summary
  const summaryData = useMemo(() => {
    const totalAllFines = finesData.reduce((sum, u) => sum + (u.totalFine || 0), 0);
    const totalPendingFines = finesData.reduce((sum, u) => sum + (u.pendingFine || 0), 0);
    const paidFines = totalAllFines - totalPendingFines;
    const percentPending = totalAllFines ? Math.round((totalPendingFines / totalAllFines) * 100) : 0;

    return {
      totalAllFines,
      totalPendingFines,
      paidFines,
      collectionRate: 100 - percentPending,
      finesUsedOnEvent
    };
  }, [finesData, finesUsedOnEvent]);

  const formatCurrency = amount => {
    return new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR", minimumFractionDigits: 0 }).format(amount);
  };

  const formatDate = date => {
    if (!date) return "";
    const d = date?.toDate ? date.toDate() : new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${d.toLocaleString("en-US", { month: "long" })}-${d.getFullYear()}`;
  };

  const handleLogout = async () => {
    try { await signOut(auth); navigate("/login"); } 
    catch (error) { console.error(error); }
  };

  const getUserPage = userId => userPage[userId] || 1;
  const setPageForUser = (userId, page) => setUserPage(prev => ({ ...prev, [userId]: page }));

  const getInitials = name => {
    if (!name) return "?";
    const parts = name.trim().split(" ");
    return parts.length === 1 ? parts[0][0].toUpperCase() : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };
  return (
    <div className="container-fluid py-4 min-vh-100 gradient-background">
      {/* Header & Actions */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card shadow-lg border-0 rounded-4 glass-card">
            <div className="card-body">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3 gap-3">
                <h2 className="h3 mb-0 text-primary fw-bold d-flex align-items-center">
                  <i className="bi bi-cash-coin me-2"></i> User Fines Overview
                </h2>
                <div className="d-flex flex-wrap gap-2">
                  <Link to="/fines" className="btn btn-success rounded-pill px-4 d-flex align-items-center">
                    <i className="bi bi-plus-circle me-2"></i> Fine Page
                  </Link>
                  <Link to="/user" className="btn btn-warning rounded-pill px-4 d-flex align-items-center">
                    <i className="bi bi-people me-2"></i> User List
                  </Link>
                  <button onClick={handleLogout} className="btn btn-outline-danger rounded-pill px-4 d-flex align-items-center">
                    <i className="bi bi-box-arrow-right me-2"></i> Logout
                  </button>
                </div>
              </div>

              {/* Search */}
              <div className="row g-3 mb-4">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="position-relative">
                    <i className="bi bi-search position-absolute ms-3" style={{ zIndex: 5, top: "50%", transform: "translateY(-50%)" }}></i>
                    <input
                      type="text"
                      className="form-control form-control-lg ps-5 rounded-pill border-0 shadow-sm"
                      placeholder="Search users or ID..."
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>

              {/* Summary Cards */}
{/* Summary Cards */}
<div className="d-flex flex-row gap-3 mb-3 w-100">
  {[
    { label: "Total Fines", value: summaryData.totalAllFines, icon: "bi-cash-stack", color: "primary", bg: "linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)", subtitle: "All fines issued" },
    { label: "Pending Fines", value: summaryData.totalPendingFines, icon: "bi-hourglass-split", color: "warning", bg: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)", subtitle: "Yet to be collected" },
    { label: "Collected Fines", value: summaryData.paidFines, icon: "bi-cash", color: "success", bg: "linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)", subtitle: "Total paid (collected)" },
    { label: "Collection Rate", value: summaryData.collectionRate + "%", icon: "bi-percent", color: "info", bg: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)", subtitle: "Fines collected" },
    { label: "Fines Used on Event", value: summaryData.finesUsedOnEvent || 0, icon: "bi-calendar-event", color: "danger", bg: "linear-gradient(135deg, #fde0e0 0%, #f7cfcf 100%)", subtitle: "Allocated for events" }
  ].map((card, i) => (
    <div key={i} className="flex-grow-1">
      <div className="card bg-gradient shadow border-0 rounded-4 h-100 glass-card" style={{ background: card.bg }}>
        <div className="card-body p-4">
          <div className="d-flex align-items-center mb-3">
            <div className={`icon-circle bg-${card.color} bg-opacity-10 text-${card.color} me-3`}>
              <i className={`bi ${card.icon}`}></i>
            </div>
            <h6 className={`fw-bold text-${card.color} mb-0`}>{card.label}</h6>
          </div>
          <h3 className="display-6 fw-bold mb-0">{typeof card.value === "number" ? formatCurrency(card.value) : card.value}</h3>
          <div className="opacity-50 mt-2 small">{card.subtitle}</div>
        </div>
      </div>
    </div>
  ))}
</div>
            </div>
          </div>
        </div>
      </div>

      {/* User Cards */}
      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-grow text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted">Loading fines data...</p>
        </div>
      ) : filteredData.length === 0 ? (
        <div className="card shadow-sm border-0 rounded-3 p-4 text-center glass-card">
          <div className="py-4">
            <i className="bi bi-search text-muted" style={{ fontSize: "3rem" }}></i>
            <h4 className="mt-3">No Results Found</h4>
            <p className="text-muted mb-0">No users found matching your search criteria.</p>
            {searchTerm && <button className="btn btn-outline-primary mt-3" onClick={() => setSearchTerm("")}>Clear Search</button>}
          </div>
        </div>
      ) : (
        <div className="row g-4">
          {filteredData.map((user, idx) => {
            const isPaid = user.pendingFine === 0 && user.totalFine > 0;
            const statusBadge = isPaid ? (
              <span className="badge bg-success rounded-pill px-3 py-2 d-flex align-items-center"><i className="bi bi-check-circle me-1"></i> Paid</span>
            ) : (
              <span className="badge bg-warning text-dark rounded-pill px-3 py-2 d-flex align-items-center"><i className="bi bi-exclamation-triangle me-1"></i> Pending</span>
            );

            const page = getUserPage(user.userId);
            const totalFines = user.fines.length;
            const totalPages = Math.ceil(totalFines / FINES_PER_PAGE) || 1;
            const paginatedFines = user.fines.slice((page - 1) * FINES_PER_PAGE, page * FINES_PER_PAGE);

            return (
              <div key={idx} className="col-12 col-lg-6">
                <div className="card shadow-lg border-0 rounded-4 overflow-hidden h-100 transition-card glass-card mb-3">
                  <div className="card-header py-3" style={{ background: "linear-gradient(90deg, #e0eafc 0%, #cfdef3 100%)" }}>
                    <div className="d-flex align-items-center gap-3">
                      <div className="rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: 48, height: 48, background: "#6c63ff", color: "#fff", fontWeight: 700, fontSize: 22 }}>
                        {getInitials(user.userName)}
                      </div>
                      <div className="flex-grow-1">
                        <div className="fw-bold fs-5 text-primary">{user.userName}</div>
                        <div className="small text-muted">ID: {user.userId}</div>
                      </div>
                      <div className="text-end">{statusBadge}</div>
                    </div>
                  </div>

                  {/* Fines Table */}
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0 sticky-header">
                        <thead className="bg-light sticky-top">
                          <tr>
                            <th>Fine Reason</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedFines.length ? paginatedFines.map((fine, i) => {
                            let fineIcon = "bi-info-circle";
                            if (fine.fineType?.toLowerCase().includes("late")) fineIcon = "bi-clock-history";
                            if (fine.fineType?.toLowerCase().includes("damage")) fineIcon = "bi-exclamation-triangle";
                            if (fine.fineType?.toLowerCase().includes("absent")) fineIcon = "bi-person-x";

                            return (
                              <tr key={i} className={i % 2 === 0 ? "table-light" : "table-white"}>
                                <td className="d-flex align-items-center gap-2"><i className={`bi ${fineIcon} text-secondary`}></i>{fine.fineType}</td>
                                <td><span className="badge bg-primary bg-opacity-10 text-primary">{formatCurrency(fine.amount)}</span></td>
                                <td className="text-muted small">{formatDate(fine.date)}</td>
                                <td>{fine.status === "Paid" 
                                  ? <span className="badge bg-success rounded-pill px-2 py-1"><i className="bi bi-check-circle me-1"></i> Paid</span>
                                  : <span className="badge bg-warning text-dark rounded-pill px-2 py-1"><i className="bi bi-clock me-1"></i> Pending</span>
                                }</td>
                              </tr>
                            );
                          }) : (
                            <tr>
                              <td colSpan="4" className="text-center py-4 text-muted"><i className="bi bi-inbox me-2"></i>No fines recorded for this user</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <nav className="d-flex justify-content-center py-2">
                        <ul className="pagination pagination-sm mb-0">
                          <li className={`page-item${page === 1 ? " disabled" : ""}`}>
                            <button className="page-link" onClick={() => setPageForUser(user.userId, page - 1)}>&laquo; Prev</button>
                          </li>
                          {Array.from({ length: totalPages }, (_, i) => (
                            <li key={i} className={`page-item${page === i + 1 ? " active" : ""}`}>
                              <button className="page-link" onClick={() => setPageForUser(user.userId, i + 1)}>{i + 1}</button>
                            </li>
                          ))}
                          <li className={`page-item${page === totalPages ? " disabled" : ""}`}>
                            <button className="page-link" onClick={() => setPageForUser(user.userId, page + 1)}>Next &raquo;</button>
                          </li>
                        </ul>
                      </nav>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Dashboard;